import { Component, ElementRef, ViewChild } from "@angular/core";
import { LayoutService } from "./service/app.layout.service";
import { MenuItems } from "./api/menuitems";
import { FilterService } from "primeng/api";
import { Router } from "@angular/router";

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

@Component({
  standalone: false,
  selector: "app-topbar",
  templateUrl: "./app.topbar.component.html",
})
export class AppTopbarComponent {
  @ViewChild("menubutton") menuButton!: ElementRef;
  suggestions: any[] = [];
  filteredGroups: any[] = [];
  input: string = "";

  constructor(
    public layoutService: LayoutService,
    private filterService: FilterService,
    private router: Router
  ) {}

  ngOnInit() {
    this.suggestions = MenuItems;
    this.filteredGroups = [];
  }

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  onProfileButtonClick() {
    this.layoutService.showProfileSidebar();
  }
  onConfigButtonClick() {
    this.layoutService.showConfigSidebar();
  }

  filterSearch(event: AutoCompleteCompleteEvent) {
    const query = event.query;
    const filteredGroups = [];

    for (const optgroup of this.suggestions) {
      const filteredSubOptions = this.filterService.filter(
        optgroup.items,
        ["label"],
        query,
        "contains"
      );
      if (filteredSubOptions && filteredSubOptions.length) {
        filteredGroups.push({
          label: optgroup.label,
          value: optgroup.value,
          items: filteredSubOptions,
        });
      }
    }

    this.filteredGroups = filteredGroups;
  }

  select(val: any) {
    if (val?.routerLink) {
      this.router.navigate(val.routerLink);
    } else {
      val.command();
    }
    this.input = "";
  }
}
